module.exports = __webpack_public_path__ + "img/3_banner.d87f97d8.png";